import { Controller } from 'stimulus';

export default class extends Controller {
  enable() {
    this.element.disabled = false;
  }
}
